<template>
  <section class="contain">
    <!-- 顶部安全区 -->
    <div class="van-safe-area-top"></div>
    <div class="prism-player" id="player-con">
      <!-- <marquee class="marquee" direction="right" scrollamount="5">{{liveData.video_statement}}</marquee> -->
    </div>
    <div class="views">
      <van-icon name="friends-o" class="views-icon" size="17px" color="#fff" />
      <span class="views-num">{{ (liveData.views / 10000).toFixed(2) }}万</span>
    </div>
    <van-swipe class="swipe" :autoplay="3000" :show-indicators="false">
      <van-swipe-item
        v-for="(item, index) in liveData.adverts"
        :key="index"
        @click="jumpUrl(item.url)"
      >
        <img class="item-img" :src="item.image" />
      </van-swipe-item>
    </van-swipe>
    <div class="introduce">
      <div class="introduce-notify" v-show="notifyShow">
        <div class="notify-left">
          <van-icon name="volume-o" color="#1684FC" size="20" class="volume" />
          <marquee class="text" direction="left" scrollamount="5">
            {{ liveData.notice }}
          </marquee>
        </div>
        <van-icon
          name="cross"
          color="#6D7077"
          size="16"
          @click="notifyShow = false"
        />
      </div>
      <van-tabs
        :active="activeName"
        color="#1684FC"
        :before-change="onClickTab"
        style="z-index: 100"
      >
        <van-tab
          title="直播简介"
          name="content"
          style="background: #fff; padding: 10px 20px"
        >
          <div
            style="overflow: scroll; height: 340px"
            v-html="liveData.content"
          ></div>
        </van-tab>
        <van-tab
          title="互动评论"
          name="list"
          v-if="id != 4 && id != 10 && id != 13"
        >
          <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <van-list
            :loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="van_list"
          >
            <div class="chat-list">
              <div
                class="chat-item"
                v-for="item in chatList"
                :key="item"
                :title="item"
              >
                <div class="bg_box">
                  <van-image
                    width="26"
                    height="26"
                    fit="cover"
                    round
                    :src="item.avatar"
                    class="chat-img"
                  />
                  <div class="chat-msg">
                    <p class="chat-username">
                      <span style="color: #666">{{ item.username }}：</span>
                      {{ item.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <!-- </van-pull-refresh> -->
          <van-search
            v-model="value"
            show-action
            placeholder="我来说两句"
            @search="onSearch"
            left-icon="chat-o"
            class="bottom-search"
          >
            <template #action>
              <van-button type="primary" @click="onClickButton" class="send-btn"
                >发送</van-button
              >
              <div class="like_btn" @click="handleLike">
                <van-icon
                  name="like"
                  size="30"
                  color="#ff1314"
                  class="like_btn_icon"
                />
                <span>{{ liveData.like }}</span>
              </div>
            </template>
          </van-search>
        </van-tab>
        <!-- <van-tab
          title="直播简介"
          name="content"
          style="background: #fff; padding: 10px 20px"
        >
          <div
            style="overflow: scroll; height: 340px"
            v-html="liveData.content"
          ></div>
        </van-tab> -->
        <!-- <van-tab title="直播抽奖" name="3"></van-tab> -->
        <van-tab title="更多直播" name="4"></van-tab>
      </van-tabs>
    </div>
    <wx-open-launch-app
      v-if="isWechat"
      id="launch-btn"
      appid="wxc9da92efaf026389"
      :extinfo="extInfo"
      style="width: 100vw; height: 16vw; left: 0; position: absolute; top: 0"
      @launch="handleLaunch"
      @error="handleError"
    >
      <div v-is="'script'" type="text/wxtag-template">
        <button
          style="
            border-width: 0;
            width: 100%;
            height: 50px;
            background: rgba(248, 1, 1, 0);
          "
        ></button>
      </div>
    </wx-open-launch-app>
    <audio v-if="id == 1" loop id="audio" ref="audioRef">
      <source :src="require('@/assets/bgmusic.mp3')" type="audio/mpeg" />
    </audio>
    <van-image
      v-if="id == 1"
      width="10vw"
      height="20vw"
      fit="cover"
      class="banner"
      :src="require('@/assets/img/banner.png')"
    />
    <van-image
      v-if="id != 1 || id != 13"
      width="5vw"
      height="5vw"
      fit="cover"
      class="logo"
      :src="require('@/assets/img/zsplus.jpg')"
    />
    <!-- 底部安全区 -->
    <div class="van-safe-area-bottom"></div>
  </section>
</template>

<script>
import {
  Image as VanImage,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Icon,
  List,
  PullRefresh,
  Toast,
  Search,
  Button,
} from "vant";
import { onMounted, ref } from "vue";
import useShare from "@/composiables/useShare";
import { useStore } from "vuex";
import Api from "../api";
import { useRoute } from "vue-router";
import "xgplayer/dist/index.min.css";
export default {
  components: {
    [VanImage.name]: VanImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    [Search.name]: Search,
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();
    const activeName = ref("content");
    const notifyShow = ref(true);
    const route = useRoute();
    const id = ref(route.query.id);
    const audioRef = ref(null); // 添加audio引用
    const isMobile = ref(false); // 移动端检测
    const isPlaying = ref(false); // 播放状态
    let activity_id = route.query.id;
    if (activity_id) {
      sessionStorage.setItem("activity_id", route.query.id);
    } else {
      activity_id = sessionStorage.getItem("activity_id");
    }
    const jumpUrl = (url) => {
      if (url) {
        window.open(url, "_blank");
      }
    };

    const onClickTab = (index) => {
      console.log(index);
      if (index == 3) {
        jumpUrl("https://zsrbactivity.zsnews.cn/vue/drawform/#/22");
        return false;
      }
      if (index == 4) {
        // router.push({ path: "/liveList" });
        jumpUrl("http://zsrbactivity.zsnews.cn/vue/slow_live/#/liveList");
        return false;
      }
      // 返回 Promise 来执行异步逻辑
      return new Promise((resolve) => {
        // 在 resolve 函数中返回 true 或 false
        resolve(index !== 3);
      });
    };
    const isWechat = navigator.userAgent.toLowerCase().indexOf("zsrbapp") < 0;

    const extInfo = ref("");
    let apkLink = "";

    const list = ref([]);
    const chatList = ref([]);
    const page = ref(1);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);

    const onLoad = () => {
      getChatlist();
    };

    let liveData = ref({});
    const player = () => {
      console.log("执行顺序", 2);
      // 引入西瓜视频播放器和HLS插件
      Promise.all([import("xgplayer"), import("xgplayer-hls")]).then(
        ([{ default: Player }, { default: HlsPlugin }]) => {
          // 清空容器内容
          const container = document.getElementById("player-con");
          if (container) {
            container.innerHTML = "";
          }

          console.log("视频源:", liveData.value.source);
          console.log("封面:", liveData.value.image);

          // 处理封面图URL，移除转义字符
          const posterUrl = liveData.value.image
            ? liveData.value.image.replace(/\\/g, "")
            : "";

          // 检测设备类型
          const isAndroid = /Android/i.test(navigator.userAgent);
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          const isMobileDevice = isAndroid || isIOS;

          // 更新响应式变量
          isMobile.value = isMobileDevice;

          const playerInstance = new Player({
            id: "player-con",
            url: liveData.value.source,
            width: "100vw",
            height: "56vw",
            autoplay: false, // 不自动播放，显示封面图和播放按钮
            isLive: true,
            loop: false,
            controls: true,
            muted: false,
            volume: 0.6,
            poster: posterUrl,
            retry: 3,
            reconnectTime: 3000,
            // 直播相关配置
            live: true,
            // 封面图相关配置
            posterOptions: {
              show: true,
              position: "center",
              size: "cover",
            },
            // 样式配置
            style: {
              width: "100%",
              height: "100%",
            },
            // 确保播放器有正确的类名
            className: "xgplayer",
            // 播放器配置
            playsinline: true,
            preload: "auto",
            // 错误处理
            errorRetry: true,
            errorRetryTime: 3000,
            // 插件配置
            plugins: [HlsPlugin],
            fullscreen: {
              fullscreen: true,
              fullscreenToggle: true,
            },
            cssFullscreen: true,
            // 移动端特殊配置
            mobileConfig: {
              enable: isMobileDevice,
              autoplay: false, // 移动端也不自动播放
              muted: false,
              playsinline: true,
            },
            // 安卓特殊配置
            androidConfig: {
              enable: isAndroid,
              autoplay: false, // 安卓也不自动播放
              muted: false,
              playsinline: true,
              preload: "auto",
            },
          });

          // 监听播放器事件
          playerInstance.on("ready", () => {
            console.log("播放器准备就绪");
            // 手动设置封面图和播放按钮
            if (posterUrl) {
              setTimeout(() => {
                // 尝试多种选择器
                let posterElement = document.querySelector(
                  ".xgplayer .xgplayer-poster"
                );
                if (!posterElement) {
                  posterElement = document.querySelector(".xgplayer-poster");
                }
                if (!posterElement) {
                  posterElement = document.querySelector(
                    "#player-con .xgplayer-poster"
                  );
                }

                if (posterElement) {
                  posterElement.style.backgroundImage = `url(${posterUrl})`;
                  posterElement.style.display = "block";
                  posterElement.style.backgroundSize = "cover";
                  posterElement.style.backgroundPosition = "center";
                  posterElement.style.backgroundRepeat = "no-repeat";
                  console.log("手动设置封面图成功:", posterUrl);
                } else {
                  console.log("未找到封面图元素，尝试创建");
                  // 如果找不到封面图元素，尝试创建
                  const playerContainer = document.querySelector(".xgplayer");
                  if (playerContainer) {
                    const newPoster = document.createElement("div");
                    newPoster.className = "xgplayer-poster";
                    newPoster.style.cssText = `
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      background-image: url(${posterUrl});
                      background-size: cover;
                      background-position: center;
                      background-repeat: no-repeat;
                      z-index: 1;
                      display: block;
                    `;
                    playerContainer.appendChild(newPoster);
                    console.log("创建封面图元素成功");
                  }
                }

                // 添加自定义播放按钮
                const playerContainer = document.querySelector(".xgplayer");
                if (
                  playerContainer &&
                  !document.querySelector(".custom-play-button")
                ) {
                  const playButton = document.createElement("div");
                  playButton.className = "custom-play-button";
                  playButton.innerHTML = `
                    <div class="play-button-icon">
                      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                        <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.6)"/>
                        <path d="M25 20L25 40L40 30L25 20Z" fill="white"/>
                      </svg>
                    </div>
                  `;
                  playButton.style.cssText = `
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 20;
                    cursor: pointer;
                    display: block;
                  `;

                  playButton.addEventListener("click", () => {
                    console.log("点击自定义播放按钮");
                    playerInstance.play().catch((err) => {
                      console.log("播放失败:", err);
                    });
                  });

                  playerContainer.appendChild(playButton);
                  console.log("创建自定义播放按钮成功");
                }
              }, 200);
            }

            // 移动端添加触摸播放支持
            if (isMobileDevice) {
              const playerElement = document.getElementById("player-con");
              if (playerElement) {
                // 添加点击播放
                playerElement.addEventListener("click", () => {
                  if (playerInstance.paused) {
                    // 立即隐藏封面图和播放按钮
                    if (posterUrl) {
                      let posterElement = document.querySelector(
                        ".xgplayer .xgplayer-poster"
                      );
                      if (!posterElement) {
                        posterElement =
                          document.querySelector(".xgplayer-poster");
                      }
                      if (!posterElement) {
                        posterElement = document.querySelector(
                          "#player-con .xgplayer-poster"
                        );
                      }
                      if (posterElement) {
                        posterElement.style.display = "none";
                        posterElement.style.visibility = "hidden";
                        posterElement.style.opacity = "0";
                        console.log("点击播放时隐藏封面图");
                      }
                    }

                    // 隐藏自定义播放按钮
                    const playButton = document.querySelector(
                      ".custom-play-button"
                    );
                    if (playButton) {
                      playButton.style.display = "none";
                      console.log("点击播放时隐藏自定义播放按钮");
                    }

                    playerInstance.play().catch((err) => {
                      console.log("播放失败，尝试静音播放:", err);
                      playerInstance.muted = false;
                      playerInstance.play();
                    });
                  }
                });

                // 添加触摸播放
                playerElement.addEventListener("touchstart", () => {
                  if (playerInstance.paused) {
                    // 立即隐藏封面图和播放按钮
                    if (posterUrl) {
                      let posterElement = document.querySelector(
                        ".xgplayer .xgplayer-poster"
                      );
                      if (!posterElement) {
                        posterElement =
                          document.querySelector(".xgplayer-poster");
                      }
                      if (!posterElement) {
                        posterElement = document.querySelector(
                          "#player-con .xgplayer-poster"
                        );
                      }
                      if (posterElement) {
                        posterElement.style.display = "none";
                        posterElement.style.visibility = "hidden";
                        posterElement.style.opacity = "0";
                        console.log("触摸播放时隐藏封面图");
                      }
                    }

                    // 隐藏自定义播放按钮
                    const playButton = document.querySelector(
                      ".custom-play-button"
                    );
                    if (playButton) {
                      playButton.style.display = "none";
                      console.log("触摸播放时隐藏自定义播放按钮");
                    }

                    playerInstance.play().catch((err) => {
                      console.log("触摸播放失败，尝试静音播放:", err);
                      playerInstance.muted = false;
                      playerInstance.play();
                    });
                  }
                });
              }
            }
          });

          playerInstance.on("play", () => {
            console.log("开始播放");
            isPlaying.value = true;
          });

          playerInstance.on("error", (err) => {
            console.error("播放器错误:", err);

            // 安卓错误处理
            if (isAndroid) {
              console.log("安卓设备播放错误，尝试重新初始化");
              setTimeout(() => {
                try {
                  playerInstance.reload();
                } catch (reloadErr) {
                  console.error("重新加载失败:", reloadErr);
                }
              }, 2000);
            }
          });

          playerInstance.on("loadstart", () => {
            console.log("开始加载视频");
          });

          playerInstance.on("canplay", () => {
            console.log("视频可以播放");
          });

          // 添加定时检查，确保播放时封面图隐藏
          let posterCheckInterval = null;
          playerInstance.on("play", () => {
            console.log("开始播放，启动封面图检查");
            if (posterCheckInterval) {
              clearInterval(posterCheckInterval);
            }
            posterCheckInterval = setInterval(() => {
              if (!playerInstance.paused && posterUrl) {
                let posterElement = document.querySelector(
                  ".xgplayer .xgplayer-poster"
                );
                if (!posterElement) {
                  posterElement = document.querySelector(".xgplayer-poster");
                }
                if (!posterElement) {
                  posterElement = document.querySelector(
                    "#player-con .xgplayer-poster"
                  );
                }
                if (posterElement && posterElement.style.display !== "none") {
                  posterElement.style.display = "none";
                  posterElement.style.visibility = "hidden";
                  posterElement.style.opacity = "0";
                  console.log("定时检查隐藏封面图");
                }
              } else if (playerInstance.paused) {
                clearInterval(posterCheckInterval);
                posterCheckInterval = null;
              }
            }, 100);
          });

          playerInstance.on("pause", () => {
            console.log("暂停播放，停止封面图检查");
            if (posterCheckInterval) {
              clearInterval(posterCheckInterval);
              posterCheckInterval = null;
            }
          });

          // 封面图相关事件
          playerInstance.on("loadedmetadata", () => {
            console.log("视频元数据加载完成");
            // 确保封面图显示
            if (posterUrl) {
              let posterElement = document.querySelector(
                ".xgplayer .xgplayer-poster"
              );
              if (!posterElement) {
                posterElement = document.querySelector(".xgplayer-poster");
              }
              if (posterElement) {
                posterElement.style.backgroundImage = `url(${posterUrl})`;
                posterElement.style.display = "block";
                console.log("元数据加载后设置封面图:", posterUrl);
              }
            }
          });

          playerInstance.on("pause", () => {
            console.log("视频暂停");
            // 暂停时显示封面图和播放按钮
            if (posterUrl) {
              let posterElement = document.querySelector(
                ".xgplayer .xgplayer-poster"
              );
              if (!posterElement) {
                posterElement = document.querySelector(".xgplayer-poster");
              }
              if (posterElement) {
                posterElement.style.display = "block";
                posterElement.style.visibility = "visible";
                posterElement.style.opacity = "1";
                console.log("暂停时显示封面图");
              }
            }

            // 显示自定义播放按钮
            const playButton = document.querySelector(".custom-play-button");
            if (playButton) {
              playButton.style.display = "block";
              console.log("暂停时显示自定义播放按钮");
            }
          });

          playerInstance.on("play", () => {
            console.log("视频开始播放");
            // 播放时隐藏封面图和播放按钮
            if (posterUrl) {
              let posterElement = document.querySelector(
                ".xgplayer .xgplayer-poster"
              );
              if (!posterElement) {
                posterElement = document.querySelector(".xgplayer-poster");
              }
              if (!posterElement) {
                posterElement = document.querySelector(
                  "#player-con .xgplayer-poster"
                );
              }
              if (posterElement) {
                posterElement.style.display = "none";
                posterElement.style.visibility = "hidden";
                posterElement.style.opacity = "0";
                console.log("播放时隐藏封面图成功");
              } else {
                console.log("播放时未找到封面图元素");
              }
            }

            // 隐藏自定义播放按钮
            const playButton = document.querySelector(".custom-play-button");
            if (playButton) {
              playButton.style.display = "none";
              console.log("播放时隐藏自定义播放按钮");
            }
          });

          // 添加更多播放相关事件监听
          playerInstance.on("playing", () => {
            console.log("视频正在播放");
            // 确保封面图隐藏
            if (posterUrl) {
              let posterElement = document.querySelector(
                ".xgplayer .xgplayer-poster"
              );
              if (!posterElement) {
                posterElement = document.querySelector(".xgplayer-poster");
              }
              if (!posterElement) {
                posterElement = document.querySelector(
                  "#player-con .xgplayer-poster"
                );
              }
              if (posterElement) {
                posterElement.style.display = "none";
                posterElement.style.visibility = "hidden";
                posterElement.style.opacity = "0";
                console.log("playing事件隐藏封面图");
              }
            }
          });

          playerInstance.on("loadstart", () => {
            console.log("开始加载视频");
            // 注意：loadstart事件不应该隐藏封面图，因为此时还没有开始播放
          });
        }
      );
    };
    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    const handleLike = () => {
      let params = { activity_id };
      Api.getLike(params).then((res) => {
        console.log(res);
        liveData.value.like++;
        // Toast(res.msg);
      });
    };

    const getLiveData = async () => {
      let params = { activity_id };
      Api.getLiveDetail(params).then((res) => {
        console.log(res.data);
        if (!res.data.notice) notifyShow.value = false;
        liveData.value = res.data;
        document.title = res.data.title;
        useShare(
          res.data.title,
          "https://zsrbactivity.zsnews.cn" + require("@/assets/img/zsplus.png"),
          "",
          window.location.href
        );
        player();
      });
    };

    const getChatlist = async (_page) => {
      if (activity_id == 4) {
        return;
      }
      let params = {
        activity_id,
        page: _page ? _page : page.value,
      };
      Api.getLiveChatlist(params)
        .then((res) => {
          // console.log(res.data);
          if (res.data.length > 0) {
            page.value++;
            chatList.value = chatList.value.concat(res.data);
          } else {
            finished.value = true;
          }

          loading.value = false;
          refreshing.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const value = ref("");
    const onSearch = () => {
      handleLiveSubmit();
    };
    const onClickButton = () => {
      handleLiveSubmit();
    };

    const handleLiveSubmit = async () => {
      if (!value.value) {
        Toast("内容不能为空");
        return;
      }
      let params = { activity_id, content: value.value };
      await Api.LiveSubmit(params).then((res) => {
        value.value = "";
        Toast(res.msg);
      });
    };
    // const proxy = getCurrentInstance(); // 移除未使用的proxy

    onMounted(() => {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          if (audioRef.value) {
            audioRef.value.play();
          }
        },
        false
      );
      document.addEventListener("touchstart", function () {
        if (audioRef.value) {
          audioRef.value.play();
        }
      });
      getLiveData();
      console.log("liveData", liveData);
      setInterval(() => {
        getChatlist();
      }, 2000);

      store.dispatch("getJump").then((res) => {
        const userAgentString = navigator.userAgent.toLowerCase();
        if (
          userAgentString.indexOf("iphone") > 0 ||
          userAgentString.indexOf("ipad") > 0
        ) {
          extInfo.value = res.iosExinfo ? res.iosExinfo : "";
        } else {
          extInfo.value = res.androidExinfo ? res.androidExinfo : "";
        }
        apkLink = res.apkLink ? res.apkLink : "";
      });
    });

    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(apkLink, "_blank");
    };

    return {
      id,
      audioRef, // 添加audioRef到return
      isMobile, // 移动端检测
      isPlaying, // 播放状态
      player,
      jumpUrl,
      extInfo,
      isWechat,
      handleLaunch,
      handleError,
      activeName,
      notifyShow,
      list,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      liveData,
      chatList,
      value,
      onSearch,
      onClickButton,
      handleLiveSubmit,
      onClickTab,
      handleLike,
    };
  },
};
</script>

<style lang="scss" scoped>
.contain {
  width: 100%;
  overflow: hidden;
  background: #f8f8f8;
  height: 100vh;
}

.prism-player {
  width: 100vw;
  height: 56vw;
  background-color: #000;
  position: relative;
  overflow: hidden;
  :deep(video) {
    width: 100%;
    height: 100%;
  }
}

/* 西瓜播放器样式覆盖 */
.prism-player :deep(.xgplayer) {
  width: 100% !important;
  height: 100% !important;
  background: #000;
}

.prism-player :deep(.xgplayer video) {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}

/* 西瓜播放器封面图样式 */
.prism-player :deep(.xgplayer .xgplayer-poster),
.prism-player :deep(.xgplayer-poster) {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  z-index: 10 !important;
  display: block !important;
}

/* 仅保留全屏按钮，隐藏其他所有控制项 */
.prism-player :deep(.xgplayer .xgplayer-controls) {
  display: flex !important;
}
.prism-player :deep(.xgplayer .xgplayer-play),
.prism-player :deep(.xgplayer .xgplayer-progress),
.prism-player :deep(.xgplayer .xgplayer-time),
.prism-player :deep(.xgplayer .xgplayer-volume),
.prism-player :deep(.xgplayer .xgplayer-playback),
.prism-player :deep(.xgplayer .xgplayer-start),
.prism-player :deep(.xgplayer .xgplayer-setting),
.prism-player :deep(.xgplayer .xgplayer-pip),
.prism-player :deep(.xgplayer .xgplayer-screen-shot),
.prism-player :deep(.xgplayer .xgplayer-definition),
.prism-player :deep(.xgplayer .xgplayer-time-current),
.prism-player :deep(.xgplayer .xgplayer-time-duration),
.prism-player :deep(.xgplayer .xgplayer-danmu),
.prism-player :deep(.xgplayer .xgplayer-airplay),
.prism-player :deep(.xgplayer .xgplayer-i18n),
.prism-player :deep(.xgplayer .xgplayer-download),
.prism-player :deep(.xgplayer .xgplayer-playnext),
.prism-player :deep(.xgplayer .xgplayer-replay),
.prism-player :deep(.xgplayer .xgplayer-screenshot),
.prism-player :deep(.xgplayer .xgplayer-enter-mini-player),
.prism-player :deep(.xgplayer .xgplayer-exit-mini-player),
.prism-player :deep(.xgplayer .xgplayer-playbackrate) {
  display: none !important;
}

/* 确保全屏按钮可见且可点击 */
.prism-player :deep(.xgplayer .xgplayer-fullscreen) {
  display: inline-flex !important;
}

/* 兼容隐藏 xg-inner-controls 内的倍速控件 */
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-playbackrate),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-playbackrate-wrap) {
  display: none !important;
}

/* 进一步隐藏倍速、静音、播放/暂停等控制按钮（外层与内层控制栏） */
/* 倍速 */
.prism-player :deep(.xgplayer .xgplayer-speed),
:deep(.xgplayer .xgplayer-playbackrate),
:deep(.xgplayer .xg-icon-pause),
:deep(.xgplayer .xg-icon-play),
:deep(.xgplayer .xgplayer-volume),
.prism-player :deep(.xgplayer .xgplayer-playback),
.prism-player :deep(.xgplayer .xgplayer-playbackrate),
.prism-player :deep(.xgplayer .xgplayer-playbackrate-wrap),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-speed),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-playback) {
  display: none !important;
}
/* 静音与音量相关 */
.prism-player :deep(.xgplayer .xgplayer-silent),
.prism-player :deep(.xgplayer .xgplayer-mute),
.prism-player :deep(.xgplayer .xgplayer-sound),
.prism-player :deep(.xgplayer .xgplayer-volume),
.prism-player :deep(.xgplayer .xgplayer-volume-panel),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-silent),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-mute),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-volume) {
  display: none !important;
}
/* 播放/暂停 */
.prism-player :deep(.xgplayer .xgplayer-play),
.prism-player :deep(.xgplayer .xgplayer-start),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-play),
.prism-player :deep(.xgplayer .xg-inner-controls .xgplayer-start) {
  display: none !important;
}

/* 确保封面图在播放前显示 */
.prism-player :deep(.xgplayer.xgplayer-paused .xgplayer-poster),
.prism-player :deep(.xgplayer.xgplayer-paused .xgplayer-poster) {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.prism-player :deep(.xgplayer.xgplayer-playing .xgplayer-poster),
.prism-player :deep(.xgplayer.xgplayer-playing .xgplayer-poster) {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 直播模式下的封面图样式 */
.prism-player :deep(.xgplayer.xgplayer-live .xgplayer-poster) {
  display: block !important;
  z-index: 5 !important;
}

/* 强制隐藏播放时的封面图 */
.prism-player :deep(.xgplayer.xgplayer-playing) .xgplayer-poster {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 确保暂停时显示封面图 */
.prism-player :deep(.xgplayer.xgplayer-paused) .xgplayer-poster {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* 自定义播放按钮样式 */
.custom-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  cursor: pointer;
  display: block;
  transition: all 0.3s ease;
}

.custom-play-button:hover {
  transform: translate(-50%, -50%) scale(1.1);
}

.play-button-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 确保播放按钮在暂停时显示 */
.prism-player :deep(.xgplayer.xgplayer-paused) .custom-play-button {
  display: block !important;
}

/* 确保播放按钮在播放时隐藏 */
.prism-player :deep(.xgplayer.xgplayer-playing) .custom-play-button {
  display: none !important;
}

.swipe {
  margin-top: 4px;

  .item-img {
    width: 100%;
  }
}

.marquee {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 14px;
  color: #fff;
  width: 290px;
  z-index: 100;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2));
}

.views {
  position: absolute;
  top: 48vw;
  left: 16px;
  font-size: 14px;
  color: #fff;
  z-index: 100;
  height: 24px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  background-color: rgba(98, 98, 98, 0.5);
  padding: 0 5px;
}

.introduce {
  width: 100%;

  .introduce-notify {
    background: #f5faff;
    color: #101010;
    font-size: 12px;
    height: 36px;
    // line-height: 36px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    .notify-left {
      display: flex;
      align-items: center;

      .text {
        width: 80vw;
        font-size: 14px;
      }

      .volume {
        margin-right: 5px;
      }
    }
  }
}

:deep(.van-list__finished-text) {
  opacity: 0;
}

.van_list {
  overflow-y: scroll;
  height: 330px;
}

.chat-list {
  // height: 340px;
  .chat-item {
    display: flex;
    align-items: center;
    padding: 2px 16px 0;
    margin-top: 5px;

    .bg_box {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      display: flex;
      padding: 6px 10px 2px 5px;
    }

    .chat-img {
      margin-right: 8px;
    }

    .chat-msg {
      box-sizing: border-box;
      max-width: 85%;

      .chat-username {
        margin: 0;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}

.bottom-search {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
  height: 78px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 0;
  background: #fff;

  // box-sizing: border-box;
  :deep(.van-search__content) {
    height: 36px;
    border-radius: 16px;
  }

  :deep(.van-search__action) {
    height: 36px;
    display: flex;
    align-items: center;
  }

  :deep(.van-search__field) {
    display: flex;
    align-items: center;
  }

  .send-btn {
    height: 36px;
    border-radius: 8px;
    padding: 0 20px;
    font-size: 14px;
  }
}

.like_btn {
  margin-left: 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #999;
  font-weight: 500;

  .like_btn_icon {
    margin-right: 4px;
  }
}

.banner {
  position: fixed;
  top: 10vw;
  right: 3vw;
  z-index: 100;
}

.logo {
  position: fixed;
  top: 3vw;
  right: 3vw;
  z-index: 100;
}
</style>
